export default {"src":"/_next/static/media/megaphone.a37ad37c.svg","height":10,"width":13,"blurWidth":0,"blurHeight":0};